import tokens from '@mineral/tokens/build/light/index.json';
export var shape = {
  borderRadius: parseInt(tokens.shape.borderRadius)
};